import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faHeart } from '@fortawesome/free-solid-svg-icons'
import confetti from 'canvas-confetti'

const OnboardingComplete = (dependant = false) => {

  useEffect(() => {
    // School pride confetti with hub colors
    const schoolPrideConfetti = () => {
      // More vibrant and contrasting colors for better visibility
      const colors = [
        '#7B5FA6',
        '#5B8FF5',
        '#5EA697',
        '#8CC290',
        '#C2968C',
        '#BE325A',
        '#3e7dba',
      ]

      confetti({
        particleCount: 120,
        spread: 80,
        origin: { y: 0.6 },
        colors: colors,
        scalar: 1.2, // Make particles 20% larger
        shapes: ['square', 'circle'], // Mix of shapes for variety
        gravity: 0.5, // Slower fall for longer visibility
        drift: 0.1, // Slight horizontal drift
      })

      // Additional burst from the left
      setTimeout(() => {
        confetti({
          particleCount: 60,
          angle: 60,
          spread: 65,
          origin: { x: 0 },
          colors: colors,
          scalar: 1.3,
          shapes: ['square', 'circle'],
          gravity: 0.6,
          drift: 0.2,
        })
      }, 300)

      // Additional burst from the right
      setTimeout(() => {
        confetti({
          particleCount: 60,
          angle: 120,
          spread: 65,
          origin: { x: 1 },
          colors: colors,
          scalar: 1.3,
          shapes: ['square', 'circle'],
          gravity: 0.6,
          drift: -0.2,
        })
      }, 600)
    }

    // Trigger confetti when component mounts
    const timer = setTimeout(() => {
      schoolPrideConfetti()
    }, 500)

    return () => clearTimeout(timer)
  }, [])
  return (
    <>
      <div className="bg-emerald-500 rounded-full p-6 mb-6 shadow-lg">
        <FontAwesomeIcon icon={faCheck} className="text-white text-4xl" />
      </div>
      <h2 className="text-3xl font-bold text-[#41264B] mb-4 text-center">
        {dependant.dependant ? 'Dependant Added!' : 'Profile Complete!'}
      </h2>
      <p className="text-lg text-[#6b4c7c] mb-6 text-center max-w-md">
        {dependant.dependant
          ? 'You can now manage their information and access services on their behalf.'
          : "Thank you for completing your profile. You can now access all the services included in your school's package."}
      </p>
    </>
  )
}

export default OnboardingComplete
